import { render, staticRenderFns } from "./StaffDepartments.vue?vue&type=template&id=986eb632&scoped=true&"
import script from "./StaffDepartments.vue?vue&type=script&lang=js&"
export * from "./StaffDepartments.vue?vue&type=script&lang=js&"
import style0 from "./StaffDepartments.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StaffDepartments.vue?vue&type=style&index=1&id=986eb632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986eb632",
  null
  
)

export default component.exports